import { useCallback, useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

export const useTextTemplate = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const getHeaders = useCallback(
    () => ({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + authCtx.token,
    }),
    [authCtx.token]
  );

  const fetchTemplates = useCallback(async () => {
    return await sendRequest({
      url: '/api/v1/textTemplate',
      method: 'GET',
      headers: getHeaders(),
    });
  }, [getHeaders, sendRequest]);

  const createTemplate = useCallback(
    async template => {
      return await sendRequest({
        url: '/api/v1/textTemplate',
        method: 'POST',
        headers: getHeaders(),
        body: template,
      });
    },
    [getHeaders, sendRequest]
  );

  const updateTemplate = useCallback(
    async (templateId, template) => {
      return await sendRequest({
        url: `/api/v1/textTemplate/${templateId}`,
        method: 'PATCH',
        headers: getHeaders(),
        body: template,
      });
    },
    [getHeaders, sendRequest]
  );

  const deleteTemplate = useCallback(
    async templateId => {
      return await sendRequest({
        url: `/api/v1/textTemplate/${templateId}`,
        method: 'DELETE',
        headers: getHeaders(),
      });
    },
    [getHeaders, sendRequest]
  );

  // Resolves the placeholders of a template for the mail being answered (customer, venue values,
  // signature). The backend is the only place that knows the current prices and links.
  const renderTemplate = useCallback(
    async (templateId, mailId) => {
      return await sendRequest({
        url: '/api/v1/textTemplate/render',
        method: 'POST',
        headers: getHeaders(),
        body: { templateId, ...(mailId ? { mailId } : {}) },
        // Inserting a text is no request to queue for approval.
        noAutoStore: true,
      });
    },
    [getHeaders, sendRequest]
  );

  return {
    isLoading,
    error,
    fetchTemplates,
    renderTemplate,
    createTemplate,
    updateTemplate,
    deleteTemplate,
  };
};
